import React from 'react';
import { connect } from 'react-redux';
import Draggable from 'react-draggable';
import { getTouchPosition } from '../utils/TransformToolUtils';
import dragManager from '../utils/DragManager';
import storeManager from '../../store/StoreManager';
import { setCurrentSlide, initSlide, selectShape, updateCurrentSlideIndex, updateCurrentSlideThumbnail, setShortcutsTarget, changeSlideDuration, changeVideoProperties } from '../../actions/CurrentSlideActions';
import { updateCurrentSlide, changeSlidePosition } from '../../actions/ProductionActions';
import { setDragTarget, setDropTarget } from '../../actions/SlideViewerActions';
import properties from '../../constants/Properties';
import { changeSlideMenuPosition } from '../../actions/MenuActions';
import { refreshAudioTrack, setMarkerPosition } from '../../actions/AudioEditorActions';
import thumbnailGenerator from '../utils/ThumbnailGenerator';
import saveManager from '../utils/SaveManager';
import mouseUtils from '../../components/utils/MouseUtils';
import zoomUtils from '../../components/utils/ZoomUtils';
import platformDetection from '../../components/utils/PlatformDetection';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import playController from '../utils/PlayController';
import hoverManager from '../utils/HoverManager';
import slidesUtils from '../utils/SlidesUtils';
import videoUtils from '../utils/VideoUtils';
import audioToolUtils from '../audioTool/utils/AudioToolUtils';
import locales from '../../locales/LocalesManager';

const ControlPoint = React.createClass({
    getInitialState () {
        return {
            isThumbOver: false
        };
    },
    isActiveThumb() {
        if (slidesUtils.currentArrow == this.props.index)
            return true;
        else
            return false;
    },
    onThumbMouseIn () {
        if (!this.isActiveThumb()) {
            hoverManager.show(this.refs.thumb, 'slideTrim');

            this.setState({
                isThumbOver: true
            });
        }
    },
    onThumbMouseOut () {
        if (!this.isActiveThumb()) {
            hoverManager.hide();

            this.setState({
                isThumbOver: false
            });
        }
    },
    onMouseDown(e) {
        hoverManager.hide();
        playController.getOldScrollPosition();

        var touchPosition = mouseUtils.getTouchPosition(e);

        slidesUtils.startPosition = touchPosition.x;
        slidesUtils.currentArrow = this.props.index;
        slidesUtils.startTime = storeManager.getState().currentSlide.model.time;
        slidesUtils.videoModel = videoUtils.getSlideVideoModel();
        slidesUtils.slideOffset = 0;
        slidesUtils.slideInitialPosition = audioEditorUtils.getMarkerPositionForSlideIndex();

        slidesUtils.initMap();
    },
    onMouseMove(e) {
        this.updateProperties(e);
    },
    onMouseUp(e) {
        this.updateProperties(e, true);

        audioEditorUtils.checkTimelineWidth();
        audioEditorUtils.addActionToHistory();
        saveManager.isContentChanged(true);
        this.props.dispatch(updateCurrentSlide());
        this.props.dispatch(refreshAudioTrack(Math.random()));

        playController.updateScrollPosition(300);

        this.setState({
            isThumbOver: false
        });
    },
    onKeyDown(e) {
        if (e.keyCode != 37 && e.keyCode != 39)
            return;

        var offsetX = 2;
        var controlPointPosition = this.refs.thumb.getBoundingClientRect();

        playController.getOldScrollPosition();

        slidesUtils.startPosition = controlPointPosition.left;
        slidesUtils.currentArrow = this.props.index;
        slidesUtils.startTime = storeManager.getState().currentSlide.model.time;
        slidesUtils.videoModel = videoUtils.getSlideVideoModel();
        slidesUtils.slideOffset = 0;
        slidesUtils.slideInitialPosition = audioEditorUtils.getMarkerPositionForSlideIndex();

        slidesUtils.initMap();

        if (e.keyCode == 37) // Left Key
            this.updateProperties(undefined, true, - offsetX);
        else
            this.updateProperties(undefined, true, offsetX);

        audioEditorUtils.checkTimelineWidth();
        audioEditorUtils.addActionToHistory();
        saveManager.isContentChanged(true);
        this.props.dispatch(updateCurrentSlide());
        this.props.dispatch(refreshAudioTrack(Math.random()));

        playController.updateScrollPosition(300);
    },
    clearProperties() {
        slidesUtils.startPosition = -1;
        slidesUtils.videoModel = undefined;
        slidesUtils.currentArrow = -1;
        slidesUtils.slideOffset = 0;
        slidesUtils.slideInitialPosition = -1;
    },
    updateProperties(e, isEndAction = false, offset = 0) {
        var offsetX;

        if (e) {
            var touchPosition = mouseUtils.getTouchPosition(e);
            offsetX = touchPosition.x - slidesUtils.startPosition;
        } else
            offsetX = offset;

        if (this.props.index == 0)
            offsetX = offsetX * (-1);

        var timeOffset = audioEditorUtils.getItemTimePosition(offsetX);
        var newTime = slidesUtils.startTime + timeOffset;
        var limit = audioEditorUtils.getItemTimePosition(properties.ARROW_SIZE * 2);

        if (newTime < limit)
            newTime = limit;

        if (slidesUtils.videoModel) {
            var inPoint = slidesUtils.videoModel.inPoint;
            var outPoint = slidesUtils.videoModel.outPoint;
            var videoDuration = parseFloat(videoUtils.getVideoTotalDuration());
            var maxDuration;

            if (outPoint == 0)
                outPoint = videoDuration;

            if (this.props.index == 0) { // left arrow
                maxDuration = outPoint;
            } else { // right arrow
                maxDuration = videoDuration - inPoint;
            }

            if (newTime > maxDuration)
                newTime = maxDuration;

            if (isEndAction) {
                var videoProps = {};

                videoProps.volume = slidesUtils.videoModel.volume;

                if (this.props.index == 0) {
                    videoProps.inPoint = outPoint - newTime;
                    videoProps.outPoint = outPoint;
                } else {
                    videoProps.inPoint = inPoint;
                    videoProps.outPoint = inPoint + newTime;
                }

                this.props.dispatch(changeVideoProperties('all', videoProps));
            }

            if (this.props.index == 0)
                videoUtils.goToPosition(outPoint - newTime);
            else
                videoUtils.goToPosition(inPoint + newTime);
        }

        if (this.props.index == 0 && newTime != slidesUtils.startTime)
            slidesUtils.slideOffset = audioEditorUtils.getSlideWidth(slidesUtils.startTime - newTime);
        else
            slidesUtils.slideOffset = 0;

        if (isEndAction) {
            if (slidesUtils.slideInitialPosition >= 0) {
                if (this.props.index == 1)
                    this.props.dispatch(setMarkerPosition(slidesUtils.slideInitialPosition + newTime));
                else
                    this.props.dispatch(setMarkerPosition(slidesUtils.slideInitialPosition));
            }

            this.clearProperties();
        }

        this.props.dispatch(changeSlideDuration(newTime));
        saveManager.isContentChanged(true);
    },
    render() {
        var height = this.props.height;
        var leftPos = this.props.offset;
        var iconSrc = 'fa fa-angle-left fa-2x';
        var iconColor = 'white';

        if (this.props.index == 1) {
            leftPos = this.props.offset + this.props.width - properties.ARROW_SIZE;
            iconSrc = 'fa fa-angle-right fa-2x';
        }

        var menuStyle = {
            position: 'absolute',
            left: leftPos,
            top: 0,
            width: properties.ARROW_SIZE,
            height: '100%',
            display: 'block',
            margin: 0,
            padding: 0,
            fontSize: 'initial',
            boxSizing: 'initial',
            borderStyle: 'none',
            background: 'none'
        };

        if (this.state.isThumbOver || this.isActiveThumb()) {
            iconColor = 'black';
        }

        var lineStyle  = {
            position: 'absolute',
            left: 0,
            top: 0,
            width: properties.ARROW_SIZE,
            height,
            background: 'black',
            opacity: 0.25,
            display: 'block'
        };

        var iconWidth = 12;
        var iconHeight = 32;
        const arrowIconStyle = {
            position: 'absolute',
            top: lineStyle.height / 2 - iconHeight / 2,
            left: lineStyle.width / 2 - iconWidth / 2,
            color: iconColor
        };

        return (
            <Draggable axis="none" position={{x:0, y:0}} onStart={this.onMouseDown} onDrag={this.onMouseMove} onStop={this.onMouseUp}>
                <button ref='thumb' aria-label={locales.getCaption('slideTrim', 'hover')} onKeyDown={this.onKeyDown} style={menuStyle} onMouseOver={this.onThumbMouseIn} onMouseOut={this.onThumbMouseOut} className={'slideElement'}>
                    <span style={lineStyle} className={'slideElement'}/>
                    <i style={arrowIconStyle} className={iconSrc + ' slideElement'}></i>
                </button>
            </Draggable>
        );
    }
});

const SlideItemRendererContent = React.createClass({
    getInitialState () {
        return {
            isOver: false,
            isMenuButtonOver: false,
            isThumbInitialized: false,
            isDrag: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false,
            isMenuButtonOver: false
        });
    },
    onMenuButtonMouseIn () {
        hoverManager.show(this.refs.editSlide, 'editSlide');

        this.setState({
            isMenuButtonOver: true
        });
    },
    onMenuButtonMouseOut () {
        hoverManager.hide();

        this.setState({
            isMenuButtonOver: false
        });
    },
    componentDidMount () {
        if (this.props.initialized == false) {
            this.props.dispatch(initSlide());
            this.updateSlideThumbnail();
        } else if (this.state.isThumbInitialized == false) {
            this.updateSlideThumbnail();

            if (platformDetection.isEdge()) {
                setTimeout(function() {
                    this.updateSlideThumbnail();
                }.bind(this), 500);
            }
        }
    },
    componentWillReceiveProps: function(nextProps) {
        if (slidesUtils.updateAllThumbnails) {
            setTimeout(function() {
                this.updateSlideThumbnail();
            }.bind(this), 50);
            return;
        }

        if (this.props.index == this.props.currentIndex) {
            if (nextProps.updateThumbnail == true)
                this.updateSlideThumbnail();
        }
    },
    updateSlideThumbnail () {
        this.props.dispatch(updateCurrentSlideThumbnail(false));
        this.takeSnapshot();
    },
    takeSnapshot() {
        thumbnailGenerator.drawThumbnail(this.refs.thumb, this.getSlideModel(), true, this.checkExtraThumbnail);

        if (this.state.isThumbInitialized == false) {
            this.setState({
                isThumbInitialized: true
            });
        }
    },
    changeSlide () {
        const state = storeManager.getState();
        const store = storeManager.getStore();
        const currentSlide = state.currentSlide;

        playController.getOldScrollPosition();

        if (this.props.index != currentSlide.currentSlideIndex)
        {
            store.dispatch(selectShape('slideFocus'));
            store.dispatch(updateCurrentSlide());
            store.dispatch(setCurrentSlide(this.props.index));
            audioEditorUtils.addActionToHistory();
            audioEditorUtils.checkMarkerPositionForCurrentSlide();
        }

        if (this.props.initialized == false) {
            store.dispatch(initSlide());
            this.updateSlideThumbnail();
        }
    },
    onShowMenu (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (playController.isPlaying)
            return;

        zoomUtils.closeZoom();

        const state = storeManager.getState();
        const menuPosition = state.menu.slideMenuLeftPosition;

        if (menuPosition >= 0)
            this.props.dispatch(changeSlideMenuPosition(-1));
        else {
            const bounds = this.refs.slideItem.getBoundingClientRect();
            this.props.dispatch(changeSlideMenuPosition(bounds.left));
        }
    },
    getSlideModel() {
        if (this.props.index == this.props.currentIndex) {
            const state = storeManager.getState();

            return state.currentSlide.model;
        }
        else {
            return this.props.slides[this.props.index];
        }
    },
    onSlideClick() { // when the slide is focused with TAB/ALT+TAB and press Enter or Space
        this.changeSlide();
    },
    startDrag(touchPosition) {
        const store = storeManager.getStore();
        store.dispatch(setDragTarget(this.props.index));

        const clone = this.refs.thumb;
        dragManager.prepareClone(clone, this.changeSlide, touchPosition, true);
    },
    onDragStart(e, coreEvent) {
        if (playController.isPlaying)
            return;

        this.props.dispatch(changeSlideMenuPosition(-1));
        this.props.dispatch(setShortcutsTarget(true));
        playController.getOldScrollPosition();

        this.setState({isDrag: true});

        if (playController.isAudioEditorMode()) {
            if (e.nativeEvent.touches && e.nativeEvent.touches.length > 0)
                dragManager.clientX = e.nativeEvent.touches[0].clientX - audioToolUtils.buttonsHolderWidth() + playController.getScrollPosition();
            else
                dragManager.clientX = e.clientX - audioToolUtils.buttonsHolderWidth() + playController.getScrollPosition();
        }

        if (mouseUtils.isActive() == false) {
            mouseUtils.pressDownAndHold(this.startDrag, getTouchPosition(e), this.changeSlide);
            return;
        }

        this.startDrag(getTouchPosition(e));
    },
    dragOver(offsetX, offsetY) {
        const store = storeManager.getStore();
        const slides = storeManager.getState().production.slides;
        let index;

        if (this.props.showAudioEditor && playController.isAudioEditorAvailable())
            index = dragManager.getDropIndexNew(this.props.dragIndex, slides, offsetX, offsetY);
        else
            index = dragManager.getDropIndex(this.props.dragIndex, slides, offsetX, offsetY);

        if (this.props.dropIndex != index)
            store.dispatch(setDropTarget(index));
    },
    onDragMove(e, coreEvent) {
        if (mouseUtils.isActive() == false) {
            return;
        }

        if (playController.isPlaying)
            return;

        this.dragOver(coreEvent.lastX, coreEvent.lastY);
        dragManager.onDragMove(coreEvent.lastX, coreEvent.lastY, e);
    },
    endDrop(coreEvent) {
        const store = storeManager.getStore();

        zoomUtils.closeZoom();

        if (Math.abs(coreEvent.lastX) < 20 && Math.abs(coreEvent.lastY) < 20) {
            // it's click event so we have to change the current slide
        } else if (this.props.dragIndex > -1 && this.props.dropIndex > -1 && this.props.dragIndex != this.props.dropIndex) {
            const state = storeManager.getState();
            const currentSlideUid = state.currentSlide.model.uuid;

            store.dispatch(changeSlidePosition(this.props.dragIndex, this.props.dropIndex));
            store.dispatch(updateCurrentSlideIndex(currentSlideUid));

            if (playController.isAudioEditorMode())
                store.dispatch(setCurrentSlide(this.props.dropIndex));

            audioEditorUtils.addActionToHistory();
            saveManager.isContentChanged(true);
            audioEditorUtils.checkMarkerPositionForCurrentSlide();
        }

        store.dispatch(setDragTarget(-1));
        store.dispatch(setDropTarget(-1));
        store.dispatch(refreshAudioTrack(Math.random()));
    },
    onDragEnd(e, coreEvent) {
        if (playController.isPlaying)
            return;

        this.setState({isDrag: false});

        if (mouseUtils.isActive() == false) {
            mouseUtils.resetSlidePositionMode(coreEvent.lastX, coreEvent.lastY);
            return;
        }

        this.dragOver(coreEvent.lastX, coreEvent.lastY);

        dragManager.onDragEnd(coreEvent.lastX, coreEvent.lastY);
        this.endDrop(coreEvent);
        mouseUtils.resetSlidePositionMode();
    },
    checkExtraThumbnail(width, originalWidth) {
        if (this.props.showAudioEditor) {
            if (this.refs.extraThumb) {
                setTimeout(function() {
                    var parent = this.refs.thumb;
                    var destination = this.refs.extraThumb;

                    if (!destination)
                        return;

                    var newCavasWidth = width - originalWidth;
                    var steps = Math.ceil(newCavasWidth / originalWidth);
                    var i;

                    if (steps > 0) {
                        var context = destination.getContext('2d');

                        for (i = 0; i < steps; i++) {
                            context.drawImage(parent, i * originalWidth, 0);
                        }
                    }
                }.bind(this), 300);
            }
        }
    },
    render() {
        const originalWidth = properties.SLIDE_ITEM_WIDTH;
        var width = properties.SLIDE_ITEM_WIDTH;
        const paddingDrop = properties.SLIDE_PADDING_DROP;
        const height = originalWidth * 9/16;
        const padding = properties.SLIDE_GAP / 2;
        let paddingLeft;
        var extraSize = 0;
        var offset = 0;

        if (this.state.isDrag)
            extraSize = 2 * properties.SLIDE_VIEWER_TOP_GAP;

        if (this.props.dragIndex > -1 && this.props.dropIndex > -1) {
            if (this.props.index == this.props.dropIndex && this.props.dragIndex != this.props.dropIndex && this.props.dragIndex + 1 != this.props.dropIndex)
                paddingLeft = paddingDrop;
            else
                paddingLeft = padding;
        } else {
            paddingLeft = padding;
        }

        var itemRendererStyle = {
            position: 'relative',
            width: width,
            height: height,
            textAlign: 'center',
            display: 'inline-block',
            marginRight: padding,
            marginLeft: paddingLeft
        };

        var itemRendererSliderStyle = {
            position: 'absolute',
            width: width,
            height: height,
            top: 0,
            left: 0,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            background: 'none',
            borderStyle: 'none'
        };

        if (this.props.showAudioEditor && playController.isAudioEditorAvailable()) {
            if (this.props.currentIndex == this.props.index && slidesUtils.slideOffset != 0) {
                if (slidesUtils.slideOffset > 0) {
                    width = audioEditorUtils.getSlideWidth(slidesUtils.startTime) - slidesUtils.slideOffset;
                    offset = slidesUtils.slideOffset;
                } else {
                    width = audioEditorUtils.getSlideWidth(slidesUtils.startTime) - slidesUtils.slideOffset;
                }
            } else
                width = audioEditorUtils.getSlideWidth(this.props.time);

            itemRendererStyle = {
                position: 'absolute',
                width: width,
                height: height,
                textAlign: 'center',
                top: 0,
                left: audioEditorUtils.slidesPosition[this.props.index],
                background: properties.SLIDE_VIEWER_BACKGROUND
            };

            if (offset > 0)
                itemRendererStyle.paddingLeft = offset;
            else {
                if (offset == 0 && this.props.dragIndex > -1 && this.props.dropIndex > -1) {
                    if (this.props.index == this.props.dropIndex && this.props.dragIndex != this.props.dropIndex && this.props.dragIndex + 1 != this.props.dropIndex)
                        itemRendererStyle.paddingLeft = paddingDrop;
                }
            }

            if (this.props.index > this.props.currentIndex && slidesUtils.slideOffset > 0)
                itemRendererStyle.left = slidesUtils.slidesDurationMap[this.props.index];
            else
            if (this.props.index >= this.props.currentIndex && slidesUtils.slideOffset < 0) {
                if (this.props.index == this.props.currentIndex)
                    itemRendererStyle.left = slidesUtils.slidesDurationMap[this.props.index] + slidesUtils.slideOffset;
                else
                    itemRendererStyle.left = slidesUtils.slidesDurationMap[this.props.index];
            }

            extraSize = 0;
        }

        let frameDisplayState;
        let frameColor;
        let menuButtonDisplayState;

        if (this.props.currentIndex == this.props.index) {
            frameDisplayState = 'block';
            menuButtonDisplayState = 'block';
            frameColor = properties.SLIDE_FRAME_SELECTED_COLOR;
        } else {
            if (this.state.isOver == true && platformDetection.isIOS() == false) {
                frameDisplayState = 'block';
                frameColor = properties.SLIDE_FRAME_HOVER_COLOR;
            } else {
                frameDisplayState = 'none';
            }
            menuButtonDisplayState = 'none';
        }

        const boderWidth = 2;

        if (this.state.isDrag) {
            frameDisplayState = 'none';
            menuButtonDisplayState = 'none';
        }

        const frameStyle = {
            width: width - 2 * boderWidth,
            height: height - 2 * boderWidth,
            borderWidth: boderWidth,
            borderStyle: 'solid',
            borderColor: frameColor,
            position: 'absolute',
            top: 0,
            display: frameDisplayState
        };

        const holderStyle = {
            position: 'absolute',
            top: 0,
            display: 'block'
        };

        var menuButtonFrameColor;

        if (this.state.isMenuButtonOver == true)
            menuButtonFrameColor = properties.SLIDE_FRAME_HOVER_COLOR;
        else
            menuButtonFrameColor = 'black';

        var thumbWidth = originalWidth;
        var leftPos = thumbWidth - (properties.SLIDE_MENU_BUTTON_RIGHT_PADDING + padding) - properties.SLIDE_MENU_BUTTON_SIZE + offset;

        if (width < originalWidth)
            thumbWidth = width;

        if (playController.isAudioEditorMode()) {
            if (width < properties.SLIDE_MENU_BUTTON_SIZE + 2 * properties.ARROW_SIZE) {
                menuButtonDisplayState = 'none';
            } else if (width < originalWidth + properties.ARROW_SIZE) {
                leftPos = width - properties.ARROW_SIZE - properties.SLIDE_MENU_BUTTON_SIZE + offset;
            }
        }

        const menuButtonStyle = {
            position: 'absolute',
            top: (height - properties.SLIDE_MENU_BUTTON_SIZE) / 2,
            left: leftPos,
            width: properties.SLIDE_MENU_BUTTON_SIZE,
            height: properties.SLIDE_MENU_BUTTON_SIZE,
            display: menuButtonDisplayState,
            background: 'white',
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: menuButtonFrameColor,
            borderRadius: 3,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial'
        };

        const menuButtonIconStyle = {
            position: 'absolute',
            top: 7,
            left: 9,
            color: menuButtonFrameColor
        };

        var borderOffset = 2;

        const thumbStyle = {
            position: 'absolute',
            top:  - extraSize / 2,
            left:  - extraSize / 2,
            width: thumbWidth - borderOffset + extraSize,
            height: height - borderOffset + extraSize,
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: 'lightgray',
            backgroundColor: '#FFFFFF'
        };

        const draggableItemStyle = {
            position: 'absolute',
            width: width,
            height: height,
            top: 0,
            background: 'red',
            opacity: 0,
            display: 'block'
        };

        var extraCanvas;
        var extraFrame;

        if (playController.isAudioEditorMode() && width > originalWidth) {
            var extraCanvasWidth = width - originalWidth;
            const extraThumbStyle = {
                position: 'absolute',
                top:  0,
                left:  originalWidth,
                width: extraCanvasWidth - borderOffset,
                height: height - borderOffset,
                borderWidth: 1,
                borderStyle: 'solid',
                borderColor: 'lightgray',
                backgroundColor: '#FFFFFF'
            };

            extraCanvas = <canvas ref="extraThumb" width={extraCanvasWidth - 2} height={height - 2} style={extraThumbStyle} className={'slideElement'}/>;

            const extraFrameStyle = {
                position: 'absolute',
                top:  1,
                left:  originalWidth,
                width: extraCanvasWidth,
                height: height - borderOffset,
                backgroundColor: '#000000',
                opacity: 0.4,
                display: 'block'
            };

            extraFrame = <span style={extraFrameStyle} className={'slideElement'}/>;

            this.checkExtraThumbnail(width, originalWidth);
        }

        var leftArrow;
        var rightArrow;
        var leftExtraPadding = 0;

        if (itemRendererStyle.paddingLeft > 0 && slidesUtils.slideOffset == 0)
            leftExtraPadding = itemRendererStyle.paddingLeft;

        if (playController.isAudioEditorMode() && this.props.currentIndex == this.props.index) {
            leftArrow = <ControlPoint width={width} height={height} offset={offset + leftExtraPadding} index={0} dispatch={this.props.dispatch} />;
            rightArrow = <ControlPoint width={width} height={height} offset={offset} index={1} dispatch={this.props.dispatch} />;
        }

        var ariaLabelValue = locales.getCaption('slide', 'other') + ' ' + (this.props.index + 1);
        var slideMenuButtonId = 'slideMenuButton_' + this.props.index;

        return (
            <div style={itemRendererStyle}>
                <button aria-label={ariaLabelValue} style={itemRendererSliderStyle} ref='item' onClick={this.onSlideClick} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} className={'slideElement'}>
                    <span ref="slideItem" style={holderStyle} className={'slideElement'}>
                        <canvas name='slideThumbnail' ref="thumb" width={originalWidth - 2} height={height - 2} style={thumbStyle} className={'slideElement'}/>
                        {extraCanvas}
                        {extraFrame}
                        <span style={frameStyle} className={'slideElement'}/>
                    </span>
                    <Draggable axis='none' position={{x:0, y:0}} onStart={this.onDragStart} onDrag={this.onDragMove} onStop={this.onDragEnd}>
                        <span style={draggableItemStyle} className={'slideElement'}/>
                    </Draggable>
                    {leftArrow}
                    {rightArrow}
                </button>

                <button id={slideMenuButtonId} aria-label={locales.getCaption('editSlide', 'hover')} className="slideMenuButton slideElement" ref='editSlide' style={menuButtonStyle} onTouchEnd={this.onShowMenu} onClick={this.onShowMenu} onMouseOver={this.onMenuButtonMouseIn} onMouseOut={this.onMenuButtonMouseOut}>
                    <i style={menuButtonIconStyle} className="fa fa-bars slideMenuButton slideElement"></i>
                </button>
            </div>
        );
    }
});

function mapStateToProps(state) {
    const dragIndex = state.slideViewer.dragIndex;
    const dropIndex = state.slideViewer.dropIndex;
    const currentIndex = state.currentSlide.currentSlideIndex;
    const updateThumbnail = state.currentSlide.updateThumbnail;
    const initialized = state.currentSlide.model.initialized;
    const isClone = state.currentSlide.model.isClone;
    const slides = state.production.slides;
    const currentSlideModel = state.currentSlide.model;
    const store = storeManager.getStore();

    return {
        dragIndex,
        dropIndex,
        currentIndex,
        updateThumbnail,
        initialized,
        isClone,
        dispatch: store.dispatch,
        slides,
        currentSlideModel
    };
}

export const SlideItemRenderer = connect(mapStateToProps)(SlideItemRendererContent);



/** WEBPACK FOOTER **
 ** ./src/components/slideViewer/SlideItemRenderer.js
 **/